<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up white--text"></v-toolbar-side-icon>
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ supplierId ? 'Edit ' + supplierId : 'Add Supplier' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left v-if="supplierId">
        <v-btn icon slot="activator" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in menuItems" :key="i" @click="clickMenu(item.title)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-content-start
          justify-center
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-text-field
              v-model="txtName"
              :rules="[v => !!v || 'Name is required']"
              :counter="100"
              label="Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtPhone"
              :rules="[v => !!v || 'Phone is required']"
              :counter="14"
              label="Phone"
              required
            ></v-text-field>

            <v-btn
              block
              large
              color="primary"
              :disabled="!frmValid"
              @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogDeleteSupplier" max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>

          <v-card-text>
            Are you sure to delete this supplier?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              class="grey--text"
              @click="dialogDeleteSupplier = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              @click="dialogDeleteSupplier = false; deleteSupplier();"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: [
    'supplierId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      loading: false,
      menuItems: [
        { title: 'Delete' }
      ],
      frmValid: true,
      txtName: '',
      txtPhone: '',
      dialogDeleteSupplier: false
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getSupplier(this.supplierId)
    this.disableBottomDetector()
  },

  methods: {
    clickMenu: function (menuTitle) {
      switch (menuTitle) {
        case 'Delete':
          this.openDeleteSupplierDialog()
          break
      }
    },
    openDeleteSupplierDialog: function () {
      this.dialogDeleteSupplier = true
    },
    deleteSupplier: function () {
      this.dialogDeleteSupplier = false
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/supplier/' + this.supplierId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            router.push('/suppliers')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getSupplier: function (supplierId) {
      if (supplierId) {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/supplier/' + supplierId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.txtName = resp.data.data.name
              this.txtPhone = resp.data.data.phone
            } else {
              console.log('unable to load supplier details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        if (this.supplierId) {
          this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/supplier/' + this.supplierId, {
            name: this.txtName,
            phone: this.txtPhone
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/suppliers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        } else {
          this.loading = true
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/supplier', {
            name: this.txtName,
            phone: this.txtPhone
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/suppliers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        }
      }
    }
  }
}
</script>
